import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import IContact from "@/interfaces/contact.interface";
import { ContactsTableMessages } from "@/messages/contacts/contacts-table.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { ContactTableRow } from "./row";
import { CONTACTS_TABLE_COLUMNS, CONTACTS_TABLE_COLUMN_WIDTHS } from "../../constants";

interface ContactTableProps {
  data: PaginatedResponse<IContact>;
  pagination: Pagination;
  messages: ContactsTableMessages;
}

export function ContactTable({ data, pagination, messages }: ContactTableProps) {
  return (
    <>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table
          stickyHeader
          aria-label="sticky table"
          sx={{ tableLayout: "fixed", width: "100%", minWidth: 1270 }}
        >
          <TableHead>
            <TableHeaderRow>
              {CONTACTS_TABLE_COLUMNS(messages).map((label, index) => (
                <HeaderTableCell
                  key={`${index} - ${label}`}
                  sx={{
                    width: CONTACTS_TABLE_COLUMN_WIDTHS[index],
                    whiteSpace: index === 5 ? "normal" : "nowrap",
                    lineHeight: index === 5 ? 1.2 : undefined,
                  }}
                >
                  {label}
                </HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items &&
              data.items.map((contact, index) => {
                return (
                  <ContactTableRow
                    key={`${index} - ${contact.email}`}
                    contact={contact}
                    index={index}
                    messages={messages}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}
